import { Fragment } from "react";
import { GetTeamsResponse, NotificationObject, teamSchema, userProfileSchema } from "../../interfaces";
import BaseText from "../BaseText";
import BaseNotificationItem from "./BaseNotificationItem";
import { NavigateFunction, useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../hooks/storeHook";
import { setAlert, toggleLoader, updateShowNotifications, updateUserTeams } from "../../store/reducers/mainReducer";
import NetworkInstance1 from "../../utils/alternate";
import useProfileData from "../../hooks/UserProfileData";
import useUserTeamsHook from "../../hooks/UseUserTeamsHook";
import { NotificationEntityTypes } from "../../interfaces/types";

interface NotificationComponentProps {
  notifications: NotificationObject[]
  deleteNotification: (arg0:string) => void
  setNotificationToRead: (arg0:string) => void
}

export default function NotificationItem({ notifications, setNotificationToRead, deleteNotification }:NotificationComponentProps) {
  const navigate: NavigateFunction = useNavigate();
  const location = useLocation();
  const { user } = useProfileData() as userProfileSchema;
  const dispatch = useAppDispatch();
  const teams = useUserTeamsHook() as teamSchema[]
  const networkInstance = NetworkInstance1();
  const currentPath = location.pathname;

  const getTeamChallenge = (teamId: string) => {
    return teams.find(team => team.id === teamId)?.challenge.id;
  }

  const handleNotificationClick = (type:'view' | 'close', id:string) => {
    
    if (type === 'view') {
      const selectedNotification = notifications.find(notification => notification.id === id);
    
      if (selectedNotification && (selectedNotification.entityType === "message" || selectedNotification.entityType === "team")) {
        dispatch(updateShowNotifications(false))
        if (teams && teams.length > 0) {
          const teamChallengeId = getTeamChallenge(selectedNotification.entityId);
          if (teamChallengeId) {
            navigate(`/challenges/${teamChallengeId}/teams/${selectedNotification.entityId}/${selectedNotification.entityType === "team" ? "overview" : "discussions"}`)
          } else {
            fetchUserTeams(selectedNotification.entityId, selectedNotification.entityType)
          }
        } else {
          fetchUserTeams(selectedNotification.entityId, selectedNotification.entityType)
        }
      } else if (selectedNotification && selectedNotification.entityType === "assessment") {
        dispatch(updateShowNotifications(false))
        if (!(currentPath === '/assessment')) {
          navigate("/assessment")
        }
      } else if (selectedNotification && selectedNotification.entityType === "challenge") {
        dispatch(updateShowNotifications(false))
        navigate(`/challenges/${selectedNotification.entityId}`);
      }
    } else {
      deleteNotification(id)
    }
    setNotificationToRead(id)
  }

  const fetchUserTeams = async (teamId:string, entityType: NotificationEntityTypes ) => {
    dispatch(toggleLoader(true))
    try {
      const URI = `/teams?userId=${user.id}`
      const { data, status } = await networkInstance.get<GetTeamsResponse>(URI);
      if(status === 200 && data) {
        if (data.items.length > 0) {
          dispatch(updateUserTeams(data.items));
          const teamChallengeId = getTeamChallenge(teamId);
          if (teamChallengeId) {
            navigate(`/challenges/${teamChallengeId}/teams/${teamId}/${entityType === "team" ? "overview" : "discussions"}`)
          } else {
            navigate(`/challenges`)
          }
        } else {
          navigate(`/challenges`)
        }
      }
    } catch(err:any) {
      const data = err?.response?.data;
      dispatch(
        setAlert({
          type: "warning",
          messageTitle: "Sorry! 🫠",
          messageBody: data?.message || "Something went wrong",
        })
      );
    } finally {
      dispatch(toggleLoader(false))
    }
  }


  return (
    <div className="bg-white border-[1px] shadow-lg w-full h-full overflow-y-scroll  md:max-h-[590px] md:w-[590px] flex flex-col rounded-lg">
      <span className="text-center mt-10">
        <BaseText weight="bold">Notifications</BaseText>
      </span>
      {notifications && notifications.length > 0 ? (
        notifications.map((notification) => (
          <Fragment key={notification.id}>
            <BaseNotificationItem notificationObject={notification} clickEvent={(clickType, id) => handleNotificationClick(clickType, id)}/>
            <div className="h-[1px] bg-[#DEDEDE]" />
          </Fragment>
        ))
      ) : (
        <h6 className="p-4 text-center" >No notifications</h6>
      )}
    </div>
  );
}
